import { pickRandomItem, RandomPickEntryList, shuffleArray } from '@/webgl/runner/core/Random'
import { CollectibleType } from '@/webgl/runner/entities/CollectibleEntity'
import { TrackEntity } from '@/webgl/runner/entities/TrackEntity'
import GameWorld from '@/webgl/runner/GameWorld'
import ICollectibleTrack from '@/webgl/runner/interfaces/ICollectibleTrack'

export type GateTrackConfig = {
  type: 'gate-track'
  gates: GateConfig[]
  /** Interval in seconds between gate spawn */
  rate: number
}

type GateConfig = {
  pool: string[]
  goals: string[]
}

export default class GateTrack implements ICollectibleTrack {
  time: number = 0

  rate: number = 0
  current: number = -1

  constructor(
    readonly world: GameWorld,
    readonly config: GateTrackConfig
  ) {
    this.rate = config.rate
  }

  generateGate(gate: GateConfig, time: number): TrackEntity[] {
    const laneCount = this.world.settings.LANE_COUNT
    const goals = [...gate.goals]
    const pool = gate.pool.filter((p) => !goals.includes(p))
    shuffleArray(pool)
    const playerLane = this.world.player.lane

    const lanesPick: RandomPickEntryList<number> = [
      [0, 1 - (playerLane == -1 ? 0.5 : 0)],
      [1, 1 - (playerLane == 0 ? 0.5 : 0)],
      [2, 1 - (playerLane == 1 ? 0.5 : 0)],
    ]
    const entities: TrackEntity[] = []

    const prices = []
    if (goals.length == 1) {
      const data = this.world.registry.collectibles.get(goals[0])
      if (data.prices && data.prices.length > 0) {
        for (let i = 0; i < data.prices.length; i++) {
          prices.push(i)
        }
      }
    }
    shuffleArray(prices)

    for (let i = 0; i < laneCount; i++) {
      let lane = pickRandomItem(lanesPick)
      lanesPick[lane][1] = 0
      lane -= 1

      let id = goals.length > 0 ? goals.shift() : pool.shift()

      if (id == undefined) {
        id = gate.pool[Math.floor(Math.random() * gate.pool.length)]
      }

      entities.push({ time, lane, data: { id }, priceID: prices.shift() })
    }

    return entities
  }

  evaluate(deltaTime: number): TrackEntity[] {
    this.time += deltaTime
    if (this.time < this.rate) return []

    const obstacles = this.world.collectibles.filter((p) => p.data.type == CollectibleType.Obstacle)

    if (obstacles.length != 0 || this.world.state.value.obstacle != null) return []

    const time = this.time
    this.time = 0
    this.current += 1

    if (this.current >= this.config.gates.length) return []

    return this.generateGate(this.config.gates[this.current], time)
  }

  clear(): void {}
}
